module.exports = __webpack_public_path__ + "img/SEJ_Eventos_texto corto.caafa1fc.svg";